const set_degree = "set_degree";
const set_degrees = "set_degrees";
const set_univ = "set_univ";

export default {
  set_degree,
  set_degrees,
  set_univ,
};
